import React from "react";
import styles from "./ConfirmEmail.module.scss";
import api from "../../../../services/Api";

class ConfirmEmail extends React.Component<any, any> {
  componentDidMount() {
    let self = this;
    api
      .post("emails/sendVerifyEmail", {
        userId: this.props.userId,
      })
      .then((response) => {
        if (!response.data.success)
          self.setState({
            error: response.data.error,
          });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400 || error.response.status === 500)
            self.setState({
              error: error.response.data.error,
            });
        }
      });
  }

  render() {
    return (
      <div className={styles.ConfirmEmail}>
        Na adres <strong>{this.props.email}</strong> wysłaliśmy link
        potwierdzający.
        <br />
        <strong>Wejdź na pocztę i kliknij link</strong>
      </div>
    );
  }
}

ConfirmEmail.defaultProps = {};

export default ConfirmEmail;
